import React, { useEffect } from 'react';
import '../../assets/css/styles.css';

const Reintentos = ({ countdown }) => {
    useEffect(() => {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');
    },[]);

    const isManualMode = countdown <= 0;
    const maxTime = countdown > 5 ? 60 : 5;
    const progress = isManualMode ? 100 : (countdown / maxTime) * 100;
    const versionLabel = process.env.REACT_APP_VERSION || "0.0.0";
    const shortVersion = versionLabel.split('-')[0];

    return (
        <div className="app-content content">
            <div className="content-wrapper">
                <div className="content-body">
                    <video className="video-login-bg" autoPlay muted loop>
                        <source src={process.env.PUBLIC_URL + "/images/videos-login/video1.mp4"} type="video/mp4"/>
                    </video>
                    
                    <section className="flexbox-container">
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '400px'}}>
                                <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)'}}>
                                    
                                    {/* SOLO LOGO APP DEFAULT (Seguro ante fallas de config) */}
                                    <div className="card-header border-0 text-center pb-0" style={{ paddingTop: '2rem' }}>
                                        <img 
                                            src={process.env.PUBLIC_URL + "/images/company/logo-login-app.png"} 
                                            alt="Logo" 
                                            className="img-fluid center-block" 
                                            style={{ maxHeight: '90px', objectFit: 'contain' }} 
                                            onError={(e) => { e.target.onerror=null; e.target.style.display='none'; }}
                                        />
                                    </div>
                                    
                                    <div className="card-body" style={{ paddingTop: '1.5rem', paddingBottom: '1.5rem' }}>
                                        <div className="text-center">
                                            <div className="mb-2">
                                                <i className={`la ${isManualMode ? 'la-wifi' : 'la-server spinner'} `} style={{ fontSize: '50px', color: isManualMode ? '#dc3545' : '#ff9800' }}></i>
                                            </div>
                                            
                                            <h4 className={`font-weight-bold mb-2 ${isManualMode ? 'text-danger' : 'text-warning'}`}>
                                                {isManualMode ? "Inconvenientes en Sistema" : "Reintento de Recovery"}
                                            </h4>
                                            
                                            <p className="text-muted mb-3" style={{ fontSize: '14px' }}>
                                                {isManualMode ? (
                                                    <>
                                                        No pudimos restablecer<br />
                                                        el Sistema de forma automática<br />
                                                        <br />
                                                    </>
                                                ) : (
                                                    <>
                                                        Detectamos Inconvenientes<br />
                                                        en la Configuración de VEC Fleet<br />
                                                        <br />
                                                        Revalidando Setup . . .
                                                    </>
                                                )}
                                            </p>

                                            {!isManualMode && (
                                                <div className="progress mb-2" style={{height: '6px', borderRadius: '5px'}}>
                                                    <div className="progress-bar bg-warning" role="progressbar" style={{ width: `${progress}%`, transition: 'width 1s linear' }}></div>
                                                </div>
                                            )}
                                            
                                            <div className="mb-3">
                                                {!isManualMode ? (
                                                    <small className="text-muted">Próximo intento en <strong>{countdown}</strong> segundos</small>
                                                ) : (
                                                    <small className="text-danger font-weight-bold">Se requiere acción manual.</small>
                                                )}
                                            </div>

                                            <button className={`btn btn-block ${isManualMode ? 'btn-danger' : 'btn-outline-primary'}`} style={{borderRadius: '8px', fontWeight:'500'}} onClick={() => window.location.reload()}>
                                                <i className="la la-refresh"></i> Reintentar Ahora
                                            </button>
                                            
                                            <hr className="my-3" />
                                            <small className="text-muted">Si el problema persiste, contacte al Administrador.</small>
                                        </div>

                                        <div className="text-center mt-3">
                                            <span style={{ display: 'inline-block', fontWeight: '500', fontSize: '11px', padding: '4px 12px', color: '#6c757d', backgroundColor: '#ffffff', border: '1px solid #e0e0e0', borderRadius: '20px' }}>
                                                v{shortVersion}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Reintentos;
